<template>
  <atom-modal modalId="modal-confirm-and-equipment">
    <template #header>
      <div class="molecule-modal-confirm-and-equipment_container--header">
        <label class="molecule-modal-confirm-and-equipment__header__topic"
          >Do you want to add equipments?</label
        >
      </div>
    </template>

    <template #body>
      <div class="molecule-modal-confirm-and-equipment__body">
        <label class="text-normal">Policy</label>
        <div class="text-highlight">{{ selectedPolicy }}</div>
        <label
          v-if="selectedTagList ? selectedTagList.length > 0 : false"
          class="text-normal mt-1"
          >Tag</label
        >
        <div class="tag-list_container">
          <molecule-edit-tag
            :tagList="selectedTagList"
            :isEditable="false"
          ></molecule-edit-tag>
        </div>
        <div class="text-normal mt-1">
          Apply policy and tags to equipment list below
        </div>
        <div
          class="equipment-list__container"
          :class="{
            'long-list__container': selectedTagList
              ? selectedTagList.length === 0
              : false,
          }"
        >
          <div
            class="equipment-list"
            v-for="(equipment, index) in selectedEquipmentList"
            :key="index"
          >
            <span class="dot"></span>
            <span>{{ equipment.hostname }}</span>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="comfirm-and-cancel-button_container">
        <atom-button
          buttonId="confirm-add-equipment"
          class="mr-2"
          @click="addButtonClick"
          >Confirm</atom-button
        >
        <atom-button
          buttonId="cancel-add-equipment"
          buttonStyle="flat"
          buttonColor="dark"
          styleInButton="border: 1px solid #82868B;color: #82868B;"
          @click="cancelButtonClick"
          >Cancel</atom-button
        >
      </div>
    </template>
  </atom-modal>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomModal from "@/components/atoms/AtomModal.vue"
import MoleculeEditTag from "@/components/molecules/serverManagementModule/server/MoleculeEditTag.vue"
export default {
  name: "MoleculeModalConfirmAndEquipment",
  components: {
    AtomModal,
    MoleculeEditTag,
    AtomButton,
  },
  props: {
    modalId: {
      type: String,
      required: true,
    },
    selectedPolicy: {
      type: String,
      required: true,
    },
    selectedTagList: {
      type: Array,
      required: false,
      default: [],
    },
    selectedEquipmentList: {
      type: Array,
      required: true,
    },
  },
  emits: ["confirmAddEquipment"],
  methods: {
    addButtonClick() {
      this.$bvModal.hide(this.modalId)
      this.$emit("confirmAddEquipment")
    },
    cancelButtonClick() {
      this.$bvModal.hide(this.modalId)
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-modal-confirm-and-equipment_container--header {
  padding: 0 30px 0 30px;
}

.molecule-modal-confirm-and-equipment__header {
  &__topic {
    color: #5e5873;
    font-weight: 500;
    font-size: 22px;
    margin-top: 7px;
    margin-bottom: 0;
  }
}

.molecule-modal-confirm-and-equipment__body {
  margin-top: 10px;
  padding: 0 30px 30px 30px;
  width: 100%;
  height: 381px;
  overflow-y: auto;
}

.text-normal {
  display: block;
  font-weight: 400;
  font-size: 12px;
  overflow-wrap: break-word;
  word-break: break-word;
}

.text-highlight {
  margin-left: 5px;
  color: #7367f0;
  font-weight: 700;
  font-size: 14px;
}

.tag-list_container {
  max-height: 4em;
  line-height: 2em;
  overflow-y: auto;
}

.equipment-list__container {
  padding-left: 5px;
  max-height: 150px;
  overflow-y: auto;
  margin-top: 6px;
}

.equipment-list__container.long-list__container {
  max-height: 240px;
}

.equipment-list {
  display: flex;
  align-items: center;
  &:not(:first-child) {
    margin-top: 6px;
  }
}

.dot {
  height: 8px;
  width: 8px;
  background-color: #bbb;
  border-radius: 50%;
  margin-right: 10px;
}

.comfirm-and-cancel-button_container {
  display: flex;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .equipment-list__container {
    max-height: 175px;
  }
  .equipment-list__container.long-list__container {
    max-height: 240px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
